import produce from 'immer';
import { mergeWith } from 'lodash';
import { ApplicationPayload } from '~/types/ApplicationPayload';
import mapValuesDeep from '~/utils/mapValuesDeep';

const merge = (formState: Partial<ApplicationPayload>, newValues: Partial<ApplicationPayload>) => {
  const updatedDataWithNull = produce(formState, (draft) => {
    // merge from lodash skips undefined values
    // we replace all 'undefined' values to null
    mergeWith(draft, newValues, (obj, src, key) => {
      // skip not filled forms
      if (!Number.isNaN(parseFloat(key)) && typeof src === 'undefined') return undefined;
      if (typeof src === 'undefined') return null;
      if (src === '') return null;
      return undefined;
    });
  });
  // replace null back
  return mapValuesDeep(updatedDataWithNull, (v) => (v !== null ? v : undefined));
};

export default merge;
